import { SVGProps, Ref, forwardRef } from 'react';

export const SpeedometerFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m2.778 4.403C13.987 5.144 13.066 5 12 5c-5.25 0-7 3.5-7 7 0 1.444.298 2.887 1.016 4.085l1.33-1.33C6.983 13.978 6.8 13.036 6.8 12c0-1.483.374-2.772 1.114-3.66C8.606 7.51 9.808 6.8 12 6.8q.71.001 1.288.094zm2.32 5.317q.102.61.102 1.28c0 1.036-.183 1.978-.546 2.755l1.33 1.33C18.702 14.887 19 13.443 19 12c0-.945-.128-1.89-.417-2.765zm1.538-4.084-4.714 4.715q.08.317.078.649c0 1-.5 2-2 2s-2-1-2-2 .5-2 2-2q.364 0 .653.075l4.71-4.711z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeedometerFilledSize24Glyph.displayName = 'SpeedometerFilledSize24Glyph';
